var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export function SALogoNoBrandingLogoWhite(_a) {
    var name = _a.name, additionalProps = __rest(_a, ["name"]);
    return (React.createElement("svg", __assign({}, additionalProps, { width: "225px", height: "45px", viewBox: "0 0 225 45", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("title", null, "Company Name"),
        React.createElement("g", { id: "Logo/NoBrand", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Group", transform: "translate(0.000000, 5.000000)", fill: "#FFFFFF" },
                React.createElement("rect", { id: "Rectangle", fillOpacity: "0.8", x: "0", y: "0", width: "60", height: "35", rx: "4" }),
                React.createElement("text", { id: "COMPANY-NAME", fontFamily: "PTSans-Bold, PT Sans", fontSize: "18", fontWeight: "bold" },
                    React.createElement("tspan", { x: "76", y: "23" }, "COMPANY NAME"))))));
}
//# sourceMappingURL=logo.nobrandlogo-white.component.js.map